<script setup lang="ts">
    defineProps<{ imageRight?: boolean }>();
</script>

<template>
    <svg
        aria-hidden="true"
        style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
        viewBox="0 0 1 1"
    >
        <defs>
            <clipPath
                :id="imageRight ? 'mobile--right' : 'mobile'"
                clipPathUnits="objectBoundingBox"
            >
                <path
                    d="M.488 0H1v1H0V.488C0 .219.219 0 .488 0Z"
                    style="fill: #fff; fill-rule: nonzero; transform-origin: center"
                    :style="imageRight ? 'transform: rotate(90deg)' : ''"
                />
            </clipPath>
        </defs>
    </svg>
</template>
